import styled from "styled-components";
import newSimage from "../../Assets/Images/optimized/newsImage2-opt.webp";

export const HealthPageWrapper = styled.div`
  background: #f7f9f3;
`;

export const HeroSection = styled.section`
  width: 100%;
  min-height: 380px;
`;

export const HeroOverlay = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 380px;
  background-image: linear-gradient(110deg, rgba(7, 7, 7, 0.82), rgba(7, 7, 7, 0.45)), url(${(props) => props.backgroundimage});
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  color: #ffffff;
`;

export const HeroInner = styled.div`
  width: min(1100px, 92%);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
`;

export const HeroKicker = styled.p`
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-weight: 700;
  font-size: 0.82rem;
  color: ${({ theme }) => theme.colors.primary};
`;

export const HeroTitle = styled.h1`
  margin: 0;
  font-size: clamp(2rem, 5vw, 3.4rem);
  line-height: 1;
`;

export const HeroSubtitle = styled.p`
  margin: 0;
  max-width: 620px;
  font-size: 1.07rem;
  line-height: 1.7;
  color: #f0f5df;
`;

export const IntroSection = styled.section`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 2.2rem 1.25rem;
`;

export const IntroText = styled.p`
  width: min(900px, 100%);
  margin: 0;
  text-align: center;
  font-size: 1.04rem;
  line-height: 1.9;
  color: ${({ theme }) => theme.colors.text};
`;

export const ContentSection = styled.section`
  width: 100%;
  padding: 0 1.25rem 2.5rem;
`;

export const ContentGrid = styled.div`
  width: min(1120px, 100%);
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.15fr 0.85fr;
  gap: 1.4rem;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const CopyPanel = styled.article`
  background: #ffffff;
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 14px 34px rgba(10, 10, 10, 0.08);
`;

export const SectionTitle = styled.h2`
  margin: 0;
  font-size: 1.8rem;
  color: ${({ theme }) => theme.colors.darkBackground};
`;

export const SectionText = styled.p`
  margin: 0.8rem 0 0;
  color: ${({ theme }) => theme.colors.text};
  line-height: 1.8;
`;

export const SafetyList = styled.ul`
  margin: 1rem 0 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 0.7rem;
`;

export const SafetyItem = styled.li`
  background: #f4f8e8;
  border-left: 4px solid ${({ theme }) => theme.colors.primary};
  border-radius: 8px;
  padding: 0.8rem 0.9rem;
  color: ${({ theme }) => theme.colors.text};
  line-height: 1.6;
`;

export const SafetyImagePanel = styled.div`
  border-radius: 16px;
  overflow: hidden;
  min-height: 100%;
  box-shadow: 0 14px 34px rgba(10, 10, 10, 0.1);

  @media (max-width: 900px) {
    min-height: 300px;
  }
`;

export const SafetyImage = styled.div`
  width: 100%;
  height: 100%;
  background-image: linear-gradient(160deg, rgba(10, 10, 10, 0.08), rgba(10, 10, 10, 0.25)), url(${newSimage});
  background-size: cover;
  background-position: center;
`;

export const PledgeSection = styled.section`
  margin-top: 0.4rem;
  background: #0a0a0a;
  color: #ffffff;
  padding: 2.2rem 1.25rem;
  text-align: center;
`;

export const PledgeTitle = styled.h2`
  margin: 0;
  font-size: 1.8rem;
  color: ${({ theme }) => theme.colors.primary};
`;

export const PledgeText = styled.p`
  width: min(860px, 100%);
  margin: 0.9rem auto 0;
  line-height: 1.8;
  color: #edf3da;
`;

export const AccreditationSection = styled.section`
  width: 100%;
  padding: 2rem 1.25rem 2.6rem;
`;

export const AccreditationTitle = styled.h2`
  margin: 0;
  text-align: center;
  font-size: 1.8rem;
  color: ${({ theme }) => theme.colors.darkBackground};
`;

export const CredentialWrapper = styled.div`
  width: min(980px, 100%);
  margin: 1.3rem auto 0;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
  }
`;

export const AccreditationCard = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 1rem;
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 24px rgba(10, 10, 10, 0.08);
`;

export const HealthAndSafetyCreditations = styled.img`
  width: auto;
  max-width: 100%;
  height: 90px;

  @media (max-width: 767px) {
    height: 80px;
  }
`;
